import script from "./ProductDealFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDealFilters.vue?vue&type=script&setup=true&lang=js"

import "./ProductDealFilters.vue?vue&type=style&index=0&id=57ed1553&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ed1553"]])

export default __exports__